import React from "react";
import Corpo from "../components/Corpo";
import { useWebsocket } from "../hooks/websocket";
import * as desafioService from "../services/desafio";
import { startMatchMultiplayer } from "../services/match-service";
import { globalPopup, closeGlobalPopup } from "../services/popup";

export default function TabMulti(props) {
  const [user, setUser] = React.useState({});
  const [challangeAccepted, setChallangeAccepted] = React.useState(false);
  const { stompClient } = useWebsocket();
  const intervalLoop = React.useRef();
  const subscriptionChallengeResponse = React.useRef();
  const subscriptionLoggedUsers = React.useRef();

  const routeParam = props.location.pathname
    .replace("/tab/multi/", "")
    .split("/");

  const idContent = routeParam[0];
  const idTheme = routeParam[1];

  const failedToInvite = React.useCallback(() => {
    globalPopup(
      "Busca",
      true,
      [
        {
          texto: "OK",
          acao: () => {
            props.history.push("/tab/theme/multi/" + idContent);
          },
        },
      ],
      "Não encontramos ninguém que gostaria de jogar no momento. Por favor tente mais tarde."
    );
  }, [idContent, props.history]);

  const getSelectedTheme = React.useCallback(() => {
    return window.GLOBALS.categoriasArray
      .find((category) => category.id.toString() === idContent)
      .listaTemas.find((theme) => theme.id.toString() === idTheme);
  }, [idContent, idTheme]);

  const challengeResponseCallback = React.useCallback(
    (data) => {
      const messageData = JSON.parse(data.body);

      if (messageData.challengeAccepted) {
        startMatchMultiplayer(idTheme, messageData.userId)
          .then((res) => {
            let questions = res.data.map((question) => {
              question.respostas = question.listaRespostas;
              return question;
            });

            window.GLOBALS.perguntasArray = questions;
            window.GLOBALS.actualMultiplayerMatch.questions = questions;
            window.GLOBALS.actualMultiplayerMatch.themeId = idTheme;
            window.GLOBALS.actualMultiplayerMatch.guestUserId =
              window.GLOBALS.user.info.id;
            window.GLOBALS.actualMultiplayerMatch.challengedUserId =
              messageData.userId;
            window.GLOBALS.isInMultiplayer = true;

            localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

            // Copia as minhas perguntas para mandar e sincronizar com as do oponente
            messageData.questions =
              window.GLOBALS.actualMultiplayerMatch.questions;
            messageData.themeId = idTheme;
            messageData.guestUserId = window.GLOBALS.user.info.id;
            messageData.challengedUserId = messageData.userId;

            setUser(messageData);
            setChallangeAccepted(messageData.challengeAccepted);

            subscriptionChallengeResponse.current.unsubscribe(
              window.GLOBALS.user.info.id.toString()
            );
            setTimeout(() => {
              stompClient.publish({
                destination: "/app/join-challenge",
                body: JSON.stringify({ ...messageData }),
              });
            }, 2000);
          })
          .catch((err) => {
            console.error(err);
            globalPopup(
              "Erro: Acesso ao servidor! (2)",
              true,
              [
                {
                  texto: "Fechar",
                  acao: () => {
                    closeGlobalPopup();
                  },
                },
              ],
              "No momento não foi possível conectar ao servidor. Por favor tente mais tarde.\r\n\r\nObrigado."
            );
          });
      } else {
        window.GLOBALS.actualMultiplayerMatch.info = {};
      }

      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
    },
    [idTheme, stompClient]
  );

  const invite = React.useCallback(
    (challengedUser) => {
      if (!window.GLOBALS.isInMultiplayer) {
        stompClient.publish({
          destination: "/app/invite-user",
          body: JSON.stringify({
            ...challengedUser,
            themeName: getSelectedTheme().nome,
            challengerId: window.GLOBALS.user.info.id,
            challengerName: window.GLOBALS.user.info.nome,
            challengerMatchPoints: window.GLOBALS.user.info.qtdPontos,
          }),
        });
      }
    },
    [getSelectedTheme, stompClient]
  );

  const resetInvite = () => {
    window.GLOBALS.searchingUser = false;
    window.GLOBALS.openInvitation = false;
    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
    return clearInterval(intervalLoop.current);
  };

  const responseCallback = React.useCallback(
    (message = []) => {
      if (message.body) {
        window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
        const loggedUsers = JSON.parse(message.body).filter(
          (itemMessage) =>
            JSON.parse(itemMessage).userId.toString() !==
              window.GLOBALS.user.info.id.toString() ||
            window.GLOBALS.isInMultiplayer
        );

        if (!loggedUsers.length) {
          return failedToInvite();
        }

        invite(JSON.parse(loggedUsers.shift()));

        intervalLoop.current = setInterval(() => {
          if (challangeAccepted || window.GLOBALS.isInMultiplayer) {
            return resetInvite();
          } else if (!loggedUsers.length && !window.GLOBALS.isInMultiplayer) {
            resetInvite();
            return failedToInvite();
          }

          invite(JSON.parse(loggedUsers.shift()));
        }, 15000);
      }
      return subscriptionLoggedUsers.current.unsubscribe();
    },
    [challangeAccepted, failedToInvite, invite]
  );

  React.useEffect(() => {
    const abortController = new AbortController();
    window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
    window.GLOBALS.searchingUser = true;
    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

    stompClient.publish({
      destination: "/app/logged-users",
      body: JSON.stringify({ key: "users" }),
    });

    subscriptionLoggedUsers.current = stompClient.subscribe(
      "/topic/logged-users",
      responseCallback
    );

    subscriptionChallengeResponse.current = stompClient.subscribe(
      `/user/${window.GLOBALS.user.info.id.toString()}/queue/challenge-response`,
      challengeResponseCallback,
      { id: window.GLOBALS.user.info.id.toString() }
    );

    return () => {
      subscriptionLoggedUsers.current.unsubscribe();
      subscriptionChallengeResponse.current.unsubscribe();
      clearInterval(intervalLoop.current);
      window.GLOBALS.searchingUser = false;
      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
      abortController.abort();
    };
  }, [challengeResponseCallback, responseCallback, stompClient]);

  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-jogo tab-procurando-usuario pane pane-game">
          <div
            className="scroll-content ionic-scroll scroll-content-false  has-tabs-top"
            style={{ top: "0px", overflow: "hidden" }}
          >
            <div className="scroll">
              {!challangeAccepted && (
                <div className="loader" ng-hide="challangeAccepted">
                  <h2 className="loader-title">Procurando Usuário</h2>
                  <div className="loader-spin"></div>
                </div>
              )}

              {challangeAccepted && (
                <div className="adversario-panel">
                  <h2 className="adversario-panel-title">Usuário Encontrado</h2>
                  <img
                    className="adversario-panel-img"
                    alt="user picure"
                    src={desafioService.checkImg(user?.picture)}
                  />
                  <h3 className="adversario-panel-name">
                    {user?.name} - {user?.uf}
                  </h3>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
